// extracted by mini-css-extract-plugin
export default {"root":"PrizeBlock__root--2Sj29","blocks":"PrizeBlock__blocks---0GJQ","background":"PrizeBlock__background--13Z_I","root_mobile":"PrizeBlock__root_mobile--2ciBb"};